var data = [{
    'label': '₺',
    'value': '0',
}, {
    'label': '$',
    'value': '1',
}, ];


export { data };